export default __webpack_public_path__ + "static/media/ic_search.29136b7a.png";